import { Inquiry as BaseInquiry } from '../definitions/InsCommon';
import Application from './Application';


// To be deprecated in V9, we should be using events
const HomeInquiry = BaseInquiry
    .named('Inquiry')
    .props({
        application: Application, // Last known state of the application
        // quote: Quote, // selected quote
    });

export default HomeInquiry;
